<template>
  <FaceMenuTag
    :model="model"
    :excluded-uid="excludedUid"
  >
    <component
      :is="model.indexed ? 'a' : 'span'"
      slot-scope="{ addTag, removeTag, isSelected }"
      class="px-4 py-1 cursor-pointer border inline-flex whitespace-no-wrap items-center text-xs rounded"
      :class="{
        'bg-blue-grey ltr:pr-0 rtl:pl-0' : isSelected
      }"
      :href="model.indexed ? model.url : null"
      @click.prevent="addTag"
    >
      {{ model.name }}
      <button
        v-if="isSelected"
        class="inline-flex items-center justify-center w-8 h-5"
        @click.stop.prevent="removeTag"
      >
        <IconCross
          width="12px"
          height="12px"
          stroke="#334161"
        />
      </button>
    </component>
  </FaceMenuTag>
</template>

<script>
import IconCross from '@/assets/icons/icon-cross.svg'
import store from '@/components/facet/store'
import FaceMenuTag from '@/components/facet/FacetTagMenuTag.vue'


export default {
  components: {
    IconCross,
    FaceMenuTag
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    excludedUid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      store
    }
  }
}
</script>
